import { render, staticRenderFns } from "./DialogId2.vue?vue&type=template&id=3a4a72e1&scoped=true&"
import script from "./DialogId2.vue?vue&type=script&lang=js&"
export * from "./DialogId2.vue?vue&type=script&lang=js&"
import style0 from "./DialogId2.vue?vue&type=style&index=0&id=3a4a72e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4a72e1",
  null
  
)

export default component.exports